export enum ZoneType {
  REST = 'rest',
  FREE = 'free'
}
